module.exports = __webpack_public_path__ + "static/media/14 Seat Belt.787494fe.jpg";